import {
  MockMap,
} from '@ama-sdk/core';
import {
  createMockData,
} from '@dapi/sdk/spec';
import {
  acknowledgeSuccess,
  alternativeOfferInProgressJobMock,
  getAlternativeOfferConfirmationJobCompletedCheckinSucceeded,
  getAlternativeOfferConfirmationJobPendingCheckinStarted,
  getAlternativeOffersCheckin,
  retrieveOrderMockCheckinInitial,
  retrieveOrderMockCheckinSucceededLast,
} from '../../../mock/data/index';

/**
 * Mocks for check-in success scenario with alternative offer confirmation.
 */
export const checkInSuccessMock: MockMap = {
  retrieveOrder: [
    {
      mockData: retrieveOrderMockCheckinInitial
    },
    {
      mockData: retrieveOrderMockCheckinSucceededLast
    },
    {
      mockData: retrieveOrderMockCheckinSucceededLast
    }
  ],
  getOrderEligibilities: [],
  getAlternativeOffers: [
    {
      mockData: getAlternativeOffersCheckin
    }
  ],
  createAsynchronousJobForAlternativeOfferConfirmation: [createMockData(alternativeOfferInProgressJobMock)],
  getAlternativeOfferConfirmationJob: [
    {
      mockData: getAlternativeOfferConfirmationJobPendingCheckinStarted
    },
    {
      mockData: getAlternativeOfferConfirmationJobPendingCheckinStarted
    },
    {
      mockData: getAlternativeOfferConfirmationJobPendingCheckinStarted
    },
    {
      mockData: getAlternativeOfferConfirmationJobCompletedCheckinSucceeded
    }
  ],
  acknowledge: [createMockData(acknowledgeSuccess)]
};
